import React from 'react'
import styles from "./FunctionModel.module.css";
import close from "../../../../../assets/Close.svg";

const FunctionModel = ({ setSelectedFunctions, setIsFunctionModel }) => {

    const handleChange = (e) => {
        const { name, checked } = e.target;

        if (checked) {
            setSelectedFunctions((prev) => [...prev, name]);
        } else {
            setSelectedFunctions((prev) => prev.filter((func) => func !== name));
        }

    };

    return (
        <div className={styles.model}>
            <div className={styles.container}>
                <button className={styles.closeBtn} onClick={() => setIsFunctionModel(false)}>
                    <img src={close} alt="close" srcset="" />
                </button>
                <h2 className={styles.title}>Add Functions</h2>
                <div className={styles.row}>
                    <input type="checkbox" name="Min" id="Min" onChange={handleChange} />
                    <label className={styles.label} >Minimum Value</label>
                </div>
                <div className={styles.row}>
                    <input type="checkbox" name="Max" id="Max" onChange={handleChange} />
                    <label className={styles.label} >Maximum Value</label>
                </div>
                <div className={styles.row}>
                    <input type="checkbox" name="Avg" id="Avg" onChange={handleChange} />
                    <label className={styles.label} >Average Value</label>
                </div>
                <div className={styles.row}>
                    <input type="checkbox" name="Sum" id="Sum" onChange={handleChange} />
                    <label className={styles.label} >Sum Value</label>
                </div>
                <div className={styles.row}>
                    <input type="checkbox" name="Sub" id="Sub" onChange={handleChange} />
                    <label className={styles.label} >Subtraction Value</label>
                </div>

                <button className={styles.saveBtn} onClick={() => setIsFunctionModel(false)} >
                    save
                </button>

            </div>
        </div>
    )
}

export default FunctionModel